import axios from "axios";
import { getUserInfo } from "@/util/userInfo";
import store from "@/store";
const zoomHeader = "https://meeting.yunicu.com"; // zoom视频会议地址-正式

//正式
const header = "https://application.yunicu.com";
// 测试
// const header = "http://admin-dev-api.yunicu.com";

// 外包替换
const headerYUN = "https://application.yunicu.com";
//下载表格----params.ExelName为表格名字
// let { token, user_id } = getUserInfo("token,user_id");
let token = "";
let user_id = "";
if (window.localStorage.getItem("user_info")) {
  token = JSON.parse(window.localStorage.getItem("user_info")).id;
  user_id = JSON.parse(window.localStorage.getItem("user_info")).id;
}
// const yunManageheader ="https://application.yunicu.com"; //后台正式
// const yunManageheader = "http://admin-dev-api.yunicu.com"  //后台测试

// const yunApplication = 'https://application.yunicu.com';//正式
// const yunApplication = 'http://admin-dev-api.yunicu.com';//测试

export function yunManageget(url, params) {
  return axios
    .get(header + url, {
      params,
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}

export function getExel(url, params) {
  return axios
    .get(header + url, {
      params,
      responseType: "blob",
    })
    .then((res) => {
      if (!res) return;
      let blob = new Blob([res.data], {
        type: "application/vnd.ms-excel;charset=utf8",
      });
      let downloadElement = document.createElement("a");
      let href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = params.ExelName; //下载后文件名
      // downloadElement.download =decodeURIComponent(
      // res.headers['content-disposition'].split(";")[1].split("filename=")[1]); // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    })
    .catch((e) => {
      console.log(e);
    });
}

export function get(url, params) {
  return axios
    .get(header + url, {
      params,
      headers: { "x-token": user_id },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}

export function getApplication(url, params) {
  return axios
    .get(header + url, {
      params,
      headers: { "x-token": params.memberId },
    })
    .then((res) => {
      console.log("x-token", user_id);
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}

export function getHeader(url, params, headers) {
  return axios
    .get(header + url, {
      params,
      headers: headers,
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}

export function getToken(url, params) {
  return axios
    .get(header + url, {
      params,
      headers: { token: token },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}

export function postToken(url, params) {
  return axios
    .post(header + url, params, { headers: { token: token } })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}

export function putToken(url, params) {
  return axios
    .put(header + url, params, { headers: { token: token } })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}

export function delToken(url, params) {
  return axios
    .delete(header + url,{  
      params, 
      headers: { "x-token": token }
     })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}

export function yunManageGetById(url, params, header2) {
  return axios
    .get(header + url, {
      params,
      headers: { byId: user_id ? user_id : "", ...header2 },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}

// export function getById(url,params,header2){
//     return  axios.get(header+url,{
//         params,headers:{'byId':user_id ? user_id : '',...header2}
//     }).then((res)=>{
//         return res.data
//     }).catch((e)=>{
//         console.log(e)
//     })
// }

export function post(url, params, headers) {
  return axios
    .post(header + url, params, { headers: { "x-token": token, ...headers } })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}
export function put(url, params) {
  return axios
    .put(header + url, params)
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}
export function del(url, params) {
  return axios
    .delete(header + url, params)
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}
export function getMp(url, params) {
  return axios
    .get("https://yunicu-mp.yunicu.com" + url, {
      params,
      headers: { "x-token": token, "x-client-tag": "mp" },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}

// //get
// export function getVideo(url, params, headers2) {
//   return axios
//     .get(headerVideo + url, {
//       params,
//       headers: {
//         // "MemberId": user_id,
//         // "member-id": user_id,
//         // memberId: user_id,
//         // userid: user_id,
//         "x-token": user_id,
//         // "x-client-tag": Os,
//         ...headers2,
//       },
//     })
//     .then((res) => {
//       return res.data;
//     })
//     .catch((e) => {
//       console.log(e);
//     });
// }

export function delXtoken(url, params) {
  return axios
    .delete(header + url, {
      params: params,
      headers: { "x-token": user_id },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}

export function putYUNById(url, params, headers2) {
  return axios
    .put(headerYUN + url, params, {
      headers: {"byId": user_id,},
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}
export function get2Mp(url, params) {
  return axios
    .get(header + url, {
      params,
      headers: { "byId": user_id, },
      // withCredentials: true,
    })
    .then((res) => {
      // const cookies = res.headers["set-cookie"]; // 从document对象中获取当前页面的Cookie值
      // console.log("Cookies: ", cookies);
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}

export function getyunManage(url, params) {
  return axios
    .get("https://yun-new-admin-api.yunicu.com" + url, {
      params,
      headers: { "x-token": user_id },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}

export function get2ById(url,params){
  return  axios.get(header+url,{
      params,headers:{'byId':user_id}
  }).then((res)=>{
      return res.data
  }).catch((e)=>{
      console.log(e)
  })
}

export function postById(url, params) {
  return axios
    .post(header + url, params, { headers: { byId: user_id } })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}
export function delById(url, params,) {
  return axios
    .delete(header + url, {
      data: params,
      headers: {"byId": user_id},
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
}


export default {
  zoomHeader,
};

